export default __webpack_public_path__ + "static/media/impressions-7.af532016.png";